import {useCallback} from "react";
import {
    getCampaignModalPresentation,
    ModalPresentation,
    ModalPresentationUpdate,
    updateCampaignModalPresentation,
} from "@/api/ModalPresentationApi.ts";
import {useRevisionedRealtimeState} from "@/api/realtime/useRevisionedRealtimeState.ts";

const NONE: ModalPresentation = {type: "NONE", contentId: null, revision: -1};

export function useCampaignModalPresentation(campaignId: string) {
    const load = useCallback(() => getCampaignModalPresentation(campaignId), [campaignId]);
    const update = useCallback(
        (change: ModalPresentationUpdate) => updateCampaignModalPresentation(campaignId, change),
        [campaignId],
    );

    return useRevisionedRealtimeState({
        topic: `/campaigns/${campaignId}/modal-presentation`,
        initialValue: NONE,
        load,
        update,
    });
}
